import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { z } from 'zod';
import { UserGroupFromValues } from './types';

const createSchema = (t: TFunction<readonly ['common']>) => {
  return z.object({
    name: z.string().min(1, t('common:required')),
    predicate: z
      .object({
        dsl: z.string().min(1, t('common:required')),
        dslHuman: z.string().nullish(),
      })
      .refine((value) => value.dsl || value.dslHuman, { error: t('common:required') }),
    users: z
      .array(
        z.object({
          id: z.number(),
        }),
      )
      .optional()
      .default([]),
  }) satisfies z.ZodType<UserGroupFromValues>;
};

export const useUserGroupSchema = () => {
  const { t } = useTranslation(['common']);

  return createSchema(t);
};
